var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.buttons),function(button){return _c('elw-button',{key:button.value,attrs:{"size":"mini","type":"primary"},on:{"click":function($event){_vm.start勘定科目Create(button.value)}}},[_vm._v(_vm._s(button.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }